export const HEADER_BACKGROUND = "#313131"
export const CONTENT_BACKGROUND = "#212121"

export const COYOTE_ORANGE = "#B64323"
export const PENNY_COLOR = "#D4B7FF"
export const PONK_COLOR = "#CBD5FF"
export const MURPLE_COLOR = "#7C40FF"